/**
 * APEX v7.8.9 — Conseils actionnables par axe
 *
 * Pour chaque axe de l'APEX Score, des conseils CONCRETS sur comment
 * s'améliorer (pas juste "ton CS est bas" mais "voici quoi faire").
 * Le ton est direct, orienté SoloQ ADC.
 */

export const AXIS_ADVICE = {
  cs_per_min: {
    label: 'CS/min',
    whatItMeasures: "Ta capacité à farmer efficacement. Un bon ADC convertit le temps de jeu en or.",
    target: "Vise 8+ CS/min en Master, 9+ pour viser GM.",
    tips: [
      "Ne lâche jamais une vague pour un gank incertain — l'or perdu est définitif.",
      "Travaille tes last-hits sous tourelle : 2 coups de tourelle + 1 auto sur les casters.",
      "En rotation, pousse ta vague avant de partir (slow push ou crash) pour ne rien perdre.",
      "Reviens en lane le plus vite possible après un fight — ne traîne pas en base."
    ]
  },
  kda: {
    label: 'KDA',
    whatItMeasures: "Ton ratio impact/morts. Mourir, c'est offrir or + tempo à l'ennemi.",
    target: "Vise un KDA de 3+ régulier. Au-dessus de 4 = tu domines tes games.",
    tips: [
      "Avant chaque fight, demande-toi : suis-je à portée d'être focus ? Recule d'un cran.",
      "Garde toujours un sort de mobilité / flash pour le désengage, pas l'engage.",
      "Si tu es en avance, ne prends pas de risque inutile : c'est l'ennemi qui doit forcer.",
      "Désactive l'auto-attaque agressive en teamfight : tape qui tu peux toucher en sécurité."
    ]
  },
  lane_wr_15: {
    label: 'Lane WR @15',
    whatItMeasures: "Ta domination de lane dans les 15 premières minutes (or/CS/XP vs ton adversaire).",
    target: "Gagner ta lane à 15min dans 55%+ de tes games.",
    tips: [
      "Connais ton powerspike : sais-tu à quel item/niveau tu es plus fort que ton lane opp ?",
      "Trade quand ton sort revient et que le sien est down, pas à l'aveugle.",
      "Gère la vague : gèle quand tu es faible, pousse quand tu spike ou veux back.",
      "Coordonne avec ton support : un setup de trade gagné = un avantage qui s'accumule."
    ]
  },
  damage_per_min: {
    label: 'Damage/min',
    whatItMeasures: "Ta capacité à infliger des dégâts aux champions. Un ADC qui ne tape pas ne sert à rien.",
    target: "800+ dmg/min en game moyenne, 900+ pour un vrai carry.",
    tips: [
      "En teamfight, cherche le bon angle pour taper en continu, pas un burst puis recul.",
      "Priorise les cibles que tu peux atteindre en sécurité plutôt que de chase le carry.",
      "Adapte ton build aux dégâts : crit vs squishies, létalité/on-hit selon le contexte.",
      "Ne reste pas spectateur : si tu ne peux pas DPS, c'est un problème de position."
    ]
  },
  vision: {
    label: 'Vision',
    whatItMeasures: "Ta contribution à l'information de l'équipe. Voir = ne pas mourir.",
    target: "Vision score 25+ en game normale pour un ADC.",
    tips: [
      "Achète 1 control ward à chaque back, pose-la sur un objectif ou ton entrée de jungle.",
      "Sweep avant de push ou de prendre un objectif — la vision ennemie te tue.",
      "Ward défensif quand tu pushes : la mort la plus chère est celle en territoire ennemi.",
      "Utilise tes wards de support : tu n'es pas obligé de tout faire mais participe."
    ]
  },
  deaths_per_game: {
    label: 'Deaths/game',
    whatItMeasures: "Ton nombre de morts par game. C'est l'axe le plus corrélé au climb ADC.",
    target: "Moins de 4 morts/game. Les bons grimpent souvent à 2-3.",
    tips: [
      "Avant de t'avancer, repère où sont les 5 ennemis (ou assume le pire).",
      "Une mort 'pour rien' (greed, facecheck) coûte plus qu'un kill ne rapporte.",
      "Quand tu sens que tu vas die : flash AVANT, pas après les premiers dégâts.",
      "Joue autour de ta vision : pas de vision = pas d'avancée, point."
    ]
  },
  win_rate: {
    label: 'Win rate',
    whatItMeasures: "Le résultat final. Toutes les stats servent ça : gagner.",
    target: "53%+ pour climber régulièrement.",
    tips: [
      "Ferme les games gagnées : ne prolonge pas pour 'farmer', prends les objectifs.",
      "Stoppe ta session après 2 défaites d'affilée — le tilt coûte des LP.",
      "Reconnais les games perdues : minimise les pertes, ne force pas un comeback impossible.",
      "Joue le macro : un kill en bot ne vaut rien si Baron tombe à l'autre bout."
    ]
  }
};

/**
 * Retourne le conseil structuré pour un axe donné.
 */
export function getAxisAdvice(axisKey) {
  return AXIS_ADVICE[axisKey] || null;
}
